import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";
import COMMON from "common";

const getReplacementLeaveBalance = async () => {
	try {
		const balance = await api.get.overtime.replacementLeaveBalance();
		return Number(balance) || 0;
	} catch (error) {
		return 0;
	}
};

const getLeaveTypesListing = async () => {
	let response = null;
	let errorMessage = null;

	try {
		const [res, replacementLeaveBalance] = await Promise.all([api.get.leaves.types(), getReplacementLeaveBalance()]);

		if (res?.companyBenefitLeaves) {
			//prettier-ignore
			const leaveTypes = res.companyBenefitLeaves.map(({ leaveTypeMapped, leaveType, ...o }) => ({ ...o, label: leaveTypeMapped, value: leaveType })).filter((o) => o.value !== COMMON.BENEFITS.LEAVES.CARRY_FORWARD_LEAVE);

			if (replacementLeaveBalance > 0) {
				// If got replacement leave
				const replacementLeave = leaveTypes.find((o) => o.value === COMMON.BENEFITS.LEAVES.REPLACEMENT_LEAVE);

				if (replacementLeave) {
					// Check if it exist to overwrite the balanceDays
					replacementLeave.balanceDays = replacementLeaveBalance;
				} else {
					// If not exist, add it to the list
					leaveTypes.push({ label: COMMON.BENEFITS.LEAVE_LABELS.REPLACEMENT_LEAVE, value: COMMON.BENEFITS.LEAVES.REPLACEMENT_LEAVE, balanceDays: replacementLeaveBalance });
				}
			} else {
				// If no replacement leave balance. 
				const index = leaveTypes.findIndex((o) => o.value === COMMON.BENEFITS.LEAVES.REPLACEMENT_LEAVE);

				// If it is exist as option, remove it from the list
				if (index > -1) leaveTypes.splice(index, 1);
			}

			response = { content: leaveTypes };
		}
	} catch (error) {
		errorMessage = serveRequestErrors(error);
	}

	if (response) return response;

	throw errorMessage;
};

export default getLeaveTypesListing;
